module.exports = __webpack_public_path__ + "img/robot-img5.71d8c7d6.png";